export default __webpack_public_path__ + "static/media/cn.09a74fe5.svg";